export default {
  'theme-stress-text': '#f0f6fc',
  'theme-text': '#D2D8E4',
  'theme-aide-text': '#B6BEC9',
  'theme-placeholder': '#8D96A0',
  'theme-disable-text': '#5b5d66',
  'theme-light-text': '#ffffff',
  'theme-icon-fill': '#f0f6fc',
  'theme-icon-fill-weak': '#9198a1',
  'theme-icon-fill-hover': '#2951E0',
  'theme-icon-placeholder': '#656C76',
  'theme-icon-bg': 'rgba(101, 108, 118, 0.2)',
  'theme-brand-text': '#DA203E',
  'theme-shape-icon-fill': '#BCBCD0',
  'theme-shape-icon-fill-hover': '#BCBCD0',
  'theme-shape-icon-fill-disabled': '#BCBCD0',
  'theme-icon-bg-other': '#f0f6fc',
  'theme-brand': '#DA203E',
  'theme-ui-brand': '#165dff',
  'theme-dividing-line': '#3D444D',
  'theme-line-split': '#3D444D',
  'theme-line-border': '#3d444d',
  'theme-line-border-light': '#242E43',
  'theme-disabled-line': '#505153',
  'theme-form-control-line-hover': '#3d444d',
  'theme-form-control-line-active': '#2951E0',
  'theme-form-control-line-active-checkbox': 'rgba(41,81,224,0.2)',
  'theme-btn-primary': '#165dff',
  'theme-btn-primary-hover': '#2951E0',
  'theme-btn-primary-active': '#0052d9',
  'theme-btn-primary-disabled': '#2B2D2F',
  'theme-btn-default': '#262c36',
  'theme-btn-default-hover': '#373E47',
  'theme-btn-default-disabled': '#656C76',
  'theme-btn-default-border': '#3d444d',
  'theme-btn-default-border-hover': '#3d444d',
  'theme-btn-default-border-disabled': '#656c76',
  'theme-table-header-bg': '#151b23',
  'theme-table-body-bg-hover': '#656C76',
  'theme-link': '#4493F8',
  'theme-link-light': '#94A8F0',
  'theme-link-disabled': '#193186',
  'theme-icon-hover': '#656c76',
  'theme-icon-active': '#656c76',
  'theme-num-bg': '#3F425A',
  'theme-default-bg': '#1D1D1D',
  'theme-global-bg': '#0D1117',
  'theme-bg-hover': '#0D1117',
  'theme-card-bg': '#242424',
  'theme-overlay-bg': '#151b23',
  'theme-overlay-hover-bg': '#30363d',
  'theme-disabled-bg': '#2D2E32',
  'theme-feedback-overlay-bg': '#30363D',
  'theme-badge-bg': '#3D444D',
  'theme-danger-bg': '#3F111B',
  'theme-danger': '#DA203E',
  'theme-danger-line': '#f66f6a',
  'theme-danger-text': '#DA203E',
  'theme-contrast-hover': '#831325',
  'theme-contrast-active': '#831325',
  'theme-warning-bg': '#FCE4DA',
  'theme-warning': '#ED5F22',
  'theme-warning-line': '#fa9841',
  'theme-warning-text': '#F07A47',
  'theme-success-bg': '#D6ECE2',
  'theme-success-line': '#50d4ab',
  'theme-success': '#088F4E',
  'theme-success-text': '#31A26C',
  'theme-checkbox-border-color': '#656c76',
  'theme-second-button-hover-border-color': 'rgba(101, 108, 118, 0.2)',
  'theme-tag-border-blue-color': '#653d444d',
  'theme-tag-bg-blue-color': 'rgba(41, 81, 224, 0.16)',
  'theme-tag-text-blue-color': '#2951E0',
  'theme-shadow-1':
    ' 0px 8px 24px 0px rgba(29, 31, 58, 0.04), 0px 4px 12px 0px rgba(29, 31, 58, 0.02), 0px 2px 6px 0px rgba(29, 31, 58, 0.02), 0px 1px 3px 0px rgba(29, 31, 58, 0.02);',
  'theme-shadow-2':
    '0px 8px 24px 0px rgba(29, 31, 58, 0.06), 0px 4px 12px 0px rgba(29, 31, 58, 0.06), 0px 2px 6px 0px rgba(29, 31, 58, 0.06), 0px 1px 3px 0px rgba(29, 31, 58, 0.06);',
  'theme-shadow-3':
    '0px 16px 48px 0px rgba(29, 31, 58, 0.12), 0px 8px 24px 0px rgba(29, 31, 58, 0.06), 0px 4px 12px 0px rgba(29, 31, 58, 0.06), 0px 2px 6px 0px rgba(29, 31, 58, 0.06), 0px 1px 3px 0px rgba(29, 31, 58, 0.06);',
  'theme-list-item-active-text': '#D2D8E4',
  'theme-list-item-hover-text': '#B6BEC9',
  'theme-icon-disabled-color': '#BCBCD0',
  'theme-brand-foil': '#DA203E',
  'theme-list-item-selected-bg': '#0D1117',
  'theme-contrast': '#DA203E',
  'theme-shadow': 'rgba(0,0,0,0.5)',
  'theme-primary': '#165dff',
  'theme-aihub-build-gradio': '#ED5F22',
  'theme-fullscreen-overlay-bg': '#242424',
  'theme-block': '#1D1D1D',
  'theme-menu-item': '#D2D8E4',
  'theme-menu-item-hover': '#0D1117',
  'theme-echarts-series-item-color1': '#2951E0',
  'theme-echarts-series-item-color2': '#32C5FF',
  'theme-echarts-series-item-color3': '#0091FF',
  'theme-echarts-series-item-color4': '#6236FF',
  'theme-echarts-series-item-color5': '#0CB8C6',
  'theme-echarts-series-item-color6': '#F57315',
  'theme-echarts-series-item-color7': '#E1597E',
  'theme-echarts-series-item-color8': '#4F762A',
  'theme-echarts-series-item-color9': '#555555',
  'theme-echarts-series-item-color10': '#694C1F',
  'theme-color-border': '#E6E6E8',
  'theme-echarts-calendar-item-color1': '#30363d',
  'theme-echarts-calendar-item-color2': '#ADDAC4',
  'theme-echarts-calendar-item-color3': '#5AB489',
  'theme-echarts-calendar-item-color4': '#088F4E',
  'theme-echarts-calendar-item-color5': '#066437',
  'theme-download-btn-bg': '#165DFF',
  'theme-download-btn-border-color': '#165DFF',
  'theme-download-btn-text-color': '#FFFFFF',
  'theme-download-btn-hover-bg': '#F8F8F8',
  'theme-download-btn-hover-border': '#D1D1E0',
  'theme-default-ui-bg': '#0D1117',
  'theme-area': '#0D1117',
  'theme-login-default-bg': '#0D1117',
  'theme-tab-mask-left': 'linear-gradient(90deg, rgb(13, 17, 23) 26px, rgba(13, 17, 23, 0))',
  'theme-tab-mask-right': 'linear-gradient(90deg, rgba(13, 17, 23, 0), rgb(13, 17, 23) 56px)',
  'theme-card-mask-bottom': 'linear-gradient(rgba(29, 29, 29, 0), rgba(29, 29, 29, 1))',
  'theme-info-bg': '#e9edfa',
  'theme-info': '#5e7ce0',
  'theme-info-line': '#5e7ce0',
  'theme-line': '#3D444D',
  'theme-text-selection-bg': '#30363D',
  'theme-range-item-hover-bg': '#30363d',
  'theme-label-bg': '#30363d',
  'theme-step-bg': '#DBE2FA29',
  'theme-select-bg': '#0D1117',
  'theme-release-card-border-color': '#3D444D',
  'theme-release-card-bg-color': '#1D1D1D',
  'theme-release-card-text-color': '#D2D8E4',
  'theme-state-open-bg': '#044827',
  'theme-state-finish-bg': '#8A25D929',
  'theme-code-line-bg': '#f8514966',
  'theme-code-del-change-bg': '#F851492C',
  'theme-code-ins-change-bg': '#2EA0432C',
  'theme-code-change-text': '#f0f6fc',
  'theme-code-del-change-detail-bg': '#F8514966',
  'theme-code-ins-change-detail-bg': '#2EA04366',
  'theme-code-expand-action-bg': '#388bfd66',
  'theme-code-expand-bg': '#388bfd1a',
  'theme-code-expand-text': '#9198a1',
  'theme-code-expand-hover-bg': '#0D1117',
  'theme-home-step-bg': '#2D2D2E',
  'theme-home-step-active-bg': '#D1D2D4',
  'theme-md-blockquote-border-color': '#3F425A',
  'theme-md-blockquote-bg': '#0D1117',
  'theme-collapse-rule-bg': 'linear-gradient(270deg, #1D1D1D 0%, #3F425A 100%)',
  'theme-rule-card-bg': 'linear-gradient(95.73deg, #0D1117 2.22%, #0D1117 94.01%)',
  'theme-edit-border-color': '#3D444D',
  'theme-growth-lv1-bg': 'linear-gradient(96.07deg, rgba(181, 189, 207, 0.32) 0%, rgba(213, 217, 228, 0.32) 100%)',
  'theme-growth-lv2-bg': 'linear-gradient(276.07deg, rgba(192, 213, 255, 0.32) 0%, rgba(198, 192, 236, 0.32) 100%)',
  'theme-growth-lv3-bg': 'linear-gradient(96.07deg, rgba(235, 182, 147, 0.32) 0%, rgba(237, 219, 222, 0.32) 100%)',
  'theme-vote-bg': '#0D1117',
  'theme-preference-setting-bg': '#101317',
  'theme-home-tools-bg': '#30363D',
  'theme-skeleton': '#30363d',
  'theme-md-code-bg': '#32656c76',
  'theme-mirrors-warning-msg-bg': 'rgba(251,239,216, .2)',
  'theme-code-checked-bg': 'rgba(255, 200, 157, 0.3)',
  'theme-resolve-code-left-bg': '#2B2D2F',
  'theme-resolve-code-right-bg': '#3D444D',
  'theme-resolve-code-checked-bg': 'rgba(255, 200, 157, 0.3)',
  'theme-resolve-code-origin-checked-bg': 'rgba(255, 200, 157, 0.3)',
  'theme-home-tab-color': '#F1F1F1',
  'theme-home-tab-hover-color': '#0F0F0F',
  'theme-home-tab-hover-bg-color': '#414141',
  'theme-home-tab-bg-color': '#292929',
  'theme-menu-text': '#F1F1F1',
  'theme-menu-icon-fill': '#F1F1F1',
  'theme-menu-hover-bg': '#3f3f3f',
  'theme-home-card-bg': ' linear-gradient(270deg, #1F1F1F 0%, #181818 100%)',
  'theme-home-card-shadow': '0px 4px 4px 0px rgba(24, 24, 24, 0.50)',
  'theme-home-card-border': '#2B2B2B',
  'theme-home-card-color': '#E5E7EB',
  'theme-home-card-color-placeholder': '#9ca3af',
  'theme-home-card-star-border': '#3D444D',
  'theme-home-btn-bg': '#165DFF',
  'theme-home-btn-hover': '#2951E0',
  'theme-home-btn-active': '#0052D9',
  'theme-home-btn-color': '#F1F1F1',
  'theme-task-center-modal':
    'linear-gradient(180deg, rgba(218, 32, 62, 0.1) -15.79%, rgba(0, 0, 0, 0.06) 50.73%, rgba(0, 0, 0, 0) 100%)',
  'theme-tab-left-linear': 'linear-gradient(90deg, rgba(29, 29, 29, 1) 26px, rgba(29, 29, 29, 0))',
  'theme-tab-right-linear': 'linear-gradient(90deg, rgba(29, 29, 29, 0), rgba(29, 29, 29, 1) 56px)',
  'theme-chat-aslide-text': '#B6BEC9',
  'theme-chat-aslide-select-bg': '#30363D',
  'theme-chat-aslide-time-title': '#B6BEC9',
  'theme-chat-aslide-select-bg-hover': '#30363D',
  'theme-chat-aslide-delete-bg-hover': '#30363D',
  'theme-chat-aslide-delete-icon-hover': '#30363D',
  'theme-chat-aslide-inset-mask': '#000000',
  'theme-chat-aslide-icon-bg': '#30363D',
  'theme-chat-aslide-model-hover-bg': '#30363D',
  'theme-chat-aslide-model-item-hover-bg': '#30363D',
  'theme-chat-aslide-model-title': '#ffffff',
  'theme-chat-consult-input': '#2951e03b',
  'theme-chat-consult-border-color': '#4D6BFE3D',
  'theme-chat-consult-bg-color': '#4D6BFE0A',
  'theme-chat-consult-text-color': '#4D6BFE',
  'theme-chat-bg': '#0D1117',
  'theme-chat-submit-btn': '#165DFF',
  'theme-chat-action-bg': '#1D1D1D',
  'theme-chat-action-text': '#B6BEC9',
  'theme-chat-action-border-color': '#3D444D',
  'theme-chat-action-active-bg': '#DBE2FA',
  'theme-chat-action-active-border': 'rgba(41, 81, 224, 0.5)',
  'theme-chat-project-text': '#B6BEC9',
  'theme-chat-aside-bg': '#1D1D1D',
  'theme-chat-aslide-current-delete-bg': '#212121',
  'theme-chat-aslide-agent-title': '#ffffff',
  'theme-chat-aslide-guide-title': '#ffffff',
  'theme-chat-aslide-guide-desc': '#000000',
  'theme-chat-aslide-guide-desc-bg': '#ffffff',
  'theme-chat-aslide-guide-desc-bg-hover': '#F2F2F2',
  'theme-star-hover-bg': 'linear-gradient(180deg, rgba(29, 29, 29, 0.2) 4.17%, rgba(254, 244, 227, 0.5) 100%)',
  'theme-model-card-bg': 'linear-gradient(0deg, rgba(69, 118, 255, 0.15), rgba(69, 118, 255, 0.15))',
  'theme-brand-tag-text': '#FF6F42',
  'theme-brand-tag-bg': '#FFAE0029',
  'theme-point-text': '#FFF4DB',
  'theme-im-n-bg': '#152970'
};
